<template>
  <el-dialog
    title="项目编辑"
    center
    v-model="dialogVisible"
    width="680px"
    top="40px"
  >
    <el-form
      style="padding-top: 20px"
      label-width="120px"
      :model="formData"
      :rules="rules"
      ref="formRef"
    >
      <el-form-item label="项目名称:" prop="inputProjectName" class="line">
        <el-input
          v-model="formData.inputProjectName"
          class="Input"
          placeholder="给项目起个名字"
        />
      </el-form-item>
      <el-form-item label="包名:" prop="inputPackageName" class="line">
        <el-input
          v-model="formData.inputPackageName"
          class="Input"
          placeholder="请指定包名"
        />
      </el-form-item>
      <el-form-item label="打包服务:" class="line" prop="inputPacking">
        <el-radio v-model="formData.inputPacking" :label="true">是</el-radio>
        <el-radio v-model="formData.inputPacking" :label="false">否</el-radio>
      </el-form-item>
      <el-form-item label="地区:" prop="inputRegion" class="line">
        <el-select
          v-model="formData.inputRegion"
          prop="region"
          class="Input"
          clearable
          placeholder="请选择地区"
          style="width: 100%"
        >
          <el-option
            v-for="item in region"
            :label="item.label"
            :key="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="制作人:" prop="inputProducer" class="line">
        <el-input
          v-model="formData.inputProducer"
          class="Input"
          clearable
          placeholder="请指定制作人"
        />
      </el-form-item>
      <el-form-item label="主程:" prop="inputProgramer" class="line">
        <el-input
          v-model="formData.inputProgramer"
          class="Input"
          clearable
          placeholder="请添加主程"
        />
      </el-form-item>
      <el-form-item label="项目负责人:" prop="inputPersonInCharge" class="line">
        <el-input
          v-model="formData.inputPersonInCharge"
          class="Input"
          clearable
          placeholder="请指定负责人"
        />
      </el-form-item>
      <el-form-item label="管理员:" prop="inputAdmin" class="line">
        <el-select
          class="Input"
          style="text-align: left; width: 100%"
          v-model="formData.inputAdmin"
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="请添加管理员"
        >
          <el-option
            v-for="item in admin"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注:" prop="inputRemark" class="line">
        <el-input
          v-model="formData.inputRemark"
          class="Input"
          placeholder="添加备注信息"
          type="textarea"
          :rows="3"
          style="vertical-align: top; margin-top: -5px"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <div style="display: inline-block; margin: auto">
        <el-button @click="handleClose" style="width: 100px">取 消</el-button>
        <el-button
          type="primary"
          @click="handleChange"
          style="width: 100px; margin-right: 50px"
          >保 存</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  apiGetKoaUserList,
  apiGetProjects,
  apiProjectModify,
} from "@/Api/AppApi";
import { useProjectStore } from "@/Store/ProjectStore";
import {
  ref,
  defineExpose,
  reactive,
  getCurrentInstance,
  onMounted,
} from "vue";

defineExpose({ initData });

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;

const projectStore = useProjectStore();

const rules = {
  inputProjectName: [
    { required: true, message: "请输入项目名称", trigger: "blur" },
  ],
  inputPackageName: [
    { required: true, message: "请输入包名", trigger: "blur" },
  ],
  // inputRegion: [
  //   {required: true, message: '请选择区域', trigger: 'change'}
  // ],
  // inputProducer: [
  //   {required: true, message: '请指定制作人', trigger: 'blur'}
  // ],
  // inputPersonInCharge: [
  //   {required: true, message: '请添加主程', trigger: 'blur'}
  // ],
  // inputProgramer: [
  //   {required: true, message: '请指定负责人', trigger: 'blur'}
  // ],
  inputAdmin: [{ required: true, message: "请添加管理员", trigger: "change" }],
};
const region = [
  {
    name: "珠海",
    label: "珠海",
  },
  {
    name: "北京",
    label: "北京",
  },
  {
    name: "成都",
    label: "成都",
  },
  {
    name: "大连",
    label: "大连",
  },
  {
    name: "广州",
    label: "广州",
  },
];

const admin = ref([]);
onMounted(async () => {
  const res = await apiGetKoaUserList();
  if (res.code === 0) {
    admin.value = res.data || [];
  } else {
    $message.error(res.message);
  }
});

const dialogVisible = ref(false);
const formData = reactive({
  id: "",
  inputProjectName: "",
  inputRegion: "",
  inputPackageName: "",
  inputPacking: false,
  inputRemark: "",
  inputProducer: "",
  inputProgramer: "", //主程
  inputPersonInCharge: "", //负责人
  inputAdmin: [],
});
function initData(data) {
  dialogVisible.value = true;
  for (const key in data) {
    formData[key] = data[key];
  }
}

function handleClose() {
  dialogVisible.value = false;
}

const formRef = ref(null);
function handleChange() {
  formRef.value.validate(async (valid) => {
    if (valid) {
      const postData = {
        name: formData.inputProjectName,
        region: formData.inputRegion,
        packagename: formData.inputPackageName,
        packing: formData.inputPacking.toString(),
        remark: formData.inputRemark,
        producer: formData.inputProducer,
        programer: formData.inputProgramer, //主程
        personincharge: formData.inputPersonInCharge, //负责人
        admins: formData.inputAdmin,
        id: formData.id,
      };
      const res = await apiProjectModify(postData);
      if (res.code === 0) {
        handleClose();
        const resp = await apiGetProjects();
        if (resp.code === 0) {
          projectStore.updateProjectList(resp.data);
        } else {
          $message.error(resp.message);
        }
      } else {
        $message.error(res.message);
        return;
      }
    }
  });
}
</script>

<style scoped>
.line {
  width: 600px;
}
</style>
